/** @jsxImportSource @emotion/react */
import { Theme } from '@emotion/react';
import { Interpolation } from '@emotion/serialize';
import React, { FC, forwardRef, LegacyRef, PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet';

interface PageProps {
  title: string;
  className?: string;
  css?: Interpolation<Theme>;
}

export const Page: FC<PropsWithChildren<PageProps>> = forwardRef(
  (
    { children, title = '', className, css }: PropsWithChildren<PageProps>,
    ref: LegacyRef<HTMLDivElement>,
  ) => {
    return (
      <div ref={ref} className={className} css={css}>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        {children}
      </div>
    );
  },
);
